(function( $ ) {
    $(function() {
        //Match Height
        $('.single-column').matchHeight();        
        //scroll to anchors
        $('a[href*=#]:not([href=#])').click(function(e) {            
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                var headerBoxHeight_ = $('.header').outerHeight(true);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');                    
                if (target.length) {
                    $('html,body').animate({
                            scrollTop: target.offset().top-(headerBoxHeight_/2)
                    }, 1000);
                    return false;
                }
            }
        });
        //Toogle Mobile Menu
        $('.toggle-mobile-menu').on('click tap', function(){
            $(this).toggleClass('open');
            $('.mobile-nav').toggle().toggleClass('open');
            $('body').toggleClass('no-scroll');
        });
        //Slider
        $('.locker-slider').slick({
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5000,
            arrows: false,
            dots: false,
            infinite: true,
            centerMode: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                      slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                      centerMode: false,
                      slidesToShow: 1
                    }
                }
            ]
        });
        //404        
        function set404Height(){
            var header_height; 
            var footer_height;
            var sumHeights;
            header_height = $('.header').outerHeight(true);
            footer_height = $('.main-footer').outerHeight(true);
            //sumHeights = (header_height + footer_height);
            var mn = $(window).height() - header_height - footer_height;
            if( $('.error404 .main').outerHeight(true) <  ($('.error404 .main').outerHeight(true) + header_height + footer_height)  ){
                $('.error404 .main').css('height', mn+'px');
                $('.error404 .main').css('min-height', mn+'px');
            }            
        }
        set404Height();
        $(window).resize(function(){
            set404Height();
        });
    });
})(jQuery);